function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var defaultMeta = {
    cost: 10000,
    eliminations: false,
    hasTitle: true,
    forPoster: false,
    canSimulate: true,
    canUpdateAppearances: true,
    canUpdateChampionships: false,
    canUpdateFeuds: false
};
export var MIN_SEGMENTS_PER_PRODUCTION = 2;
export var PROMO_KEYS = [
    "PROMO",
    "DEBUT_PROMO"
];
export var SegmentsMetaCollection = [
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "DEFAULT",
        name: "Match",
        forPoster: true,
        canUpdateFeuds: true
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "TITLE_MATCH",
        name: "Title Match",
        cost: 20000,
        forPoster: true,
        canUpdateChampionships: true,
        canUpdateFeuds: true
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "INTRODUCTION",
        name: "Show Introduction",
        description: "",
        cost: 5000,
        hasTitle: false,
        canSimulate: false,
        canUpdateAppearances: false,
        canUpdateChampionships: false,
        canUpdateFeuds: false
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "ADVERT",
        name: "Advert",
        cost: 0,
        hasTitle: false,
        canSimulate: false,
        canUpdateAppearances: false,
        canUpdateChampionships: false,
        canUpdateFeuds: false
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "INTERVIEW",
        name: "Interview",
        cost: 15000,
        forPoster: true,
        canSimulate: false,
        canUpdateChampionships: false,
        canUpdateFeuds: true
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "BRAWL",
        name: "Brawl",
        cost: 5500,
        canUpdateFeuds: true
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "RUMBLE",
        name: "Rumble",
        forPoster: true,
        cost: 1000000,
        eliminations: true,
        canUpdateChampionships: true,
        canUpdateFeuds: false
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "PROMO",
        name: "Promo",
        canUpdateFeuds: true
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "ANNOUNCEMENT",
        name: "Announcement",
        forPoster: true,
        cost: 35000
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "CONTRACT_SIGNING",
        name: "Contract signing",
        cost: 50000,
        canUpdateFeuds: true
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "DEBUT_PROMO",
        name: "Debut Promo",
        cost: 100000,
        canUpdateChampionships: true,
        forPoster: true,
        canUpdateFeuds: true
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "RECAP",
        name: "Recap",
        cost: 4000,
        hasTitle: false,
        canSimulate: false,
        canUpdateAppearances: false,
        canUpdateChampionships: false,
        canUpdateFeuds: false
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "RETIREMENT",
        name: "Retirement",
        cost: 200000,
        hasTitle: false,
        canUpdateChampionships: false,
        canUpdateFeuds: true
    }),
    {
        type: "ALIGNMENT_CHANGE",
        name: "Alignment Change",
        cost: 20000,
        hasTitle: false,
        canSimulate: false,
        canUpdateFeuds: true
    },
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "BACKSTAGE_BRAWL",
        name: "Backstage brawl",
        cost: 30000,
        hasTitle: false,
        canUpdateFeuds: true
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "TALK_SHOW",
        name: "Talk Show",
        cost: 7000,
        canSimulate: false,
        forPoster: true,
        canUpdateChampionships: false,
        canUpdateFeuds: true
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "TRIBUTE",
        name: "Tribute",
        cost: 25000,
        hasTitle: false,
        canUpdateChampionships: false,
        canUpdateFeuds: false
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "MATCH_MAKING",
        name: "Match Making",
        cost: 15000,
        hasTitle: true,
        canSimulate: false,
        canUpdateFeuds: false
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "CHAMPIONSHIP_CELEBRATION",
        name: "Championship Celebration",
        cost: 100000,
        hasTitle: true,
        forPoster: true,
        canUpdateFeuds: true
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "CASKET_MATCH",
        name: "Casket Match",
        forPoster: true,
        cost: 150000,
        hasTitle: false,
        canUpdateFeuds: true
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "TRAINING_MONTAGE",
        name: "Training Montage",
        cost: 75000,
        hasTitle: false,
        canSimulate: false,
        canUpdateFeuds: false
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "TAG_TEAM_MATCH",
        name: "Tag Team Match",
        cost: 8000,
        canUpdateFeuds: true
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "GRUDGE_MATCH",
        name: "Grudge Match",
        cost: 9500,
        canUpdateFeuds: true
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "LADDER_MATCH",
        name: "Ladder Match",
        forPoster: true,
        cost: 50000,
        canUpdateFeuds: true
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "STREET_FIGHT",
        name: "Street Fight",
        forPoster: true,
        cost: 50000,
        canUpdateFeuds: true
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "BATTLE_ROYAL",
        name: "Battle Royal",
        forPoster: true,
        cost: 50000,
        canUpdateFeuds: false
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "AWARD_CEREMONY",
        name: "Award",
        cost: 50000,
        canUpdateChampionships: false,
        canUpdateFeuds: true
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "WARGAMES",
        name: "War Games",
        forPoster: true,
        cost: 100000,
        canUpdateChampionships: true,
        canUpdateFeuds: true
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "LAST_MAN_STANDING_MATCH",
        name: "Last man standing",
        forPoster: true,
        cost: 30000,
        canUpdateFeuds: true
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "IRON_MAN_MATCH",
        name: "Iron man match",
        forPoster: true,
        cost: 30000,
        canUpdateFeuds: true
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "SUBMISSION_MATCH",
        name: "Submission match",
        forPoster: true,
        cost: 30000,
        canUpdateFeuds: true
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "NO_HOLD_BARRED_MATCH",
        name: "No holds barred match",
        forPoster: true,
        cost: 30000,
        canUpdateFeuds: true
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "BLOODBATH_MATCH",
        name: "Bloodbath match",
        forPoster: true,
        cost: 30000,
        canUpdateFeuds: true
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "DARK_MATCH",
        name: "Dark Match",
        canUpdateChampionships: false,
        cost: 3000,
        canUpdateFeuds: true
    }),
    _object_spread_props(_object_spread({}, defaultMeta), {
        type: "OPEN_CHALLENGE",
        name: "Open Challenge",
        forPoster: true,
        cost: 30000,
        canUpdateFeuds: false
    })
];
export var SegmentsMeta = SegmentsMetaCollection.reduce(function(acc, segment) {
    acc[segment.type] = segment;
    return acc;
}, {});
export var SegmentTypes = _object_spread({}, Object.keys(SegmentsMeta));
